import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import {
  VolumeUpIcon,
  CollectionIcon,
  IdentificationIcon,
  ChatAltIcon,
  CalendarIcon,
  DocumentTextIcon,
  CurrencyDollarIcon,
  StarIcon,
  AnnotationIcon,
  BookOpenIcon,
} from "@heroicons/react/outline";
import SideFooter from "../../components/sidebar/SideFooter";
import { getStudentsGlobal } from "../../api/endpoints/students/statistics";
import { useAuth } from "../../context/AuthContext";
import SidebarWithHeader from "../../components/Layouts/SidebarWithHaeder";
import AppLogo from "../../components/AppLogo";
import { makeApiRequest } from "../../helpers";
import {
  showApologizeRequests,
  showChangeScheduleRequests,
} from "../../api/endpoints/students/requests";
import { ApiResponse } from "../../api/apiResponse";
import RequestsModel from "../../api/models/RequestsModel";
import { showStudentStatistics } from "../../api/endpoints/students/students";
import { StatisticsType } from "../../api/@types/scheduleTypes";

function StudentDashboardPage() {
  const [unpassedNotesCount, setUnpassedNotesCount] = useState(0);
  const [langModal, setLangModal] = useState(false);
  const userContext = useAuth();
  const LocalNavBasePath = "page.student.dashboard.nav";
  const { t, i18n } = useTranslation();
  const [requestsReceived, setRequestsReceived] = useState<RequestsModel[]>([]);
  const [scheduleRequests, setScheduleRequests] = useState<number | string>(0);

  const getStudentUnscheduledReaders = async () => {
    const response: any = await getStudentsGlobal();
    setUnpassedNotesCount(response.data.unpassed_notes_count);
  };
  const showReceivedCancelRequests = async () => {
    await makeApiRequest(
      () =>
        showApologizeRequests({
          filters: { sender_type: "Tutor", status: "pending" },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] =
            RequestsModel.fromApiResponsePending(data, "receiver");
          setRequestsReceived(requestsList);
        }
      }
    );
  };
  const getStatistics = async () => {
    try {
      const res = await showStudentStatistics();
      if (res.isSuccess) {
        const { schedule_requests }: StatisticsType = res.data;
        setScheduleRequests(schedule_requests);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    showReceivedCancelRequests();
    getStatistics();
    getStudentUnscheduledReaders();
  }, []);
  const navigation: any = [
    {
      name: t(`${LocalNavBasePath}.homePage`),
      href: "/student/dashboard/room",
      icon: VolumeUpIcon,
      separate: "bottom",
    },
    {
      name: t(`${LocalNavBasePath}.weeklySchedule`),
      href: "/student/dashboard/weekly-schedule",
      icon: CalendarIcon,
    },
    {
      name: t(`${LocalNavBasePath}.readingSessions`),
      href: "/student/dashboard/sessions",
      icon: CollectionIcon,
      separate: "bottom",
    },
    {
      name: t(`${LocalNavBasePath}.recitationNotes`),
      href: "/student/dashboard/notes",
      icon: ChatAltIcon,
      counter: unpassedNotesCount,
    },
    {
      name: t(`${LocalNavBasePath}.recitationEvaluation`),
      icon: StarIcon,
      href: "/student/dashboard/recitation-skills",
      separate: "bottom",
    },

    {
      name: t(`${LocalNavBasePath}.requests`),
      icon: DocumentTextIcon,
      separate: "bottom",
      counter: scheduleRequests,
      children: [
        {
          name: t(`${LocalNavBasePath}.apologizeSession`),
          href: "/student/dashboard/requests",
          counter: requestsReceived.length,
        },
        {
          name: t(`${LocalNavBasePath}.changeAppointment`),
          href: "/student/dashboard/appointments-requests",
        },
      ],
    },
    {
      name: t(`${LocalNavBasePath}.paymentOfSubscriptions`),
      href: "/student/dashboard/payment",
      icon: CurrencyDollarIcon,
    },

    {
      name: t(`${LocalNavBasePath}.myPersonalData`),
      href: "/student/dashboard/personal-info",
      icon: IdentificationIcon,
    },
    {
      name: t(`${LocalNavBasePath}.politics`),
      href:
        i18n.language === "ar"
          ? "https://www.sanadquran.com/ar/privacy-policy-2/"
          : "https://www.sanadquran.com/en/privacy-policy-2/",
      icon: AnnotationIcon,
      isBrowserLink: true,
    },
    {
      name: t(`${LocalNavBasePath}.tutorial`),
      href:
        i18n.language === "ar"
          ? "https://www.sanadquran.com/ar/tutorial-video-student/"
          : "https://www.sanadquran.com/en/tutorial-video-student/",
      icon: BookOpenIcon,
      isBrowserLink: true,
      separate: "bottom",
    },
  ];

  const userImg = userContext?.currentUser?.profile_picture_url;

  return (
    <div className="">
      <div className="">
        <SidebarWithHeader
          langModal={langModal}
          setLangModal={setLangModal}
          img={userImg}
          navigation={navigation}
          sideHeader={
            <div className="w-full px-2 pt-5 pb-4">
              <AppLogo />
            </div>
          }
          sideFooter={
            <SideFooter langModal={langModal} setLangModal={setLangModal} />
          }
        ></SidebarWithHeader>
      </div>
    </div>
  );
}
export default StudentDashboardPage;
